import React from 'react';
import { SegmentSliceProps, StateIconType, SliceButton } from './types';
import style from './style.module.scss';
import cx from 'classnames';
import { Col, Row } from 'react-bootstrap';
import { SecondaryButton, DefaultButton } from '@magoosh/lib/button';
import { pluralize } from 'utilities/pluralize';
import { paths } from 'config/path_helpers';

import CircleCheckmark from '../../assets/circle_checkmark.svg';
import CircleHalfFilled from '../../assets/circle_half_filled.svg';
import CircleOpen from '../../assets/circle_open.svg';

export const SegmentSlice: React.FC<SegmentSliceProps> = (props) => {
  const { number, title, estimatedTimeMinutes, blocks, openModal, segmentIsLocked } = props;

  const stateIcon: StateIconType = {
    complete: CircleCheckmark,
    incomplete: CircleHalfFilled,
    start: CircleOpen
  };

  const buttonProps = (block) => {
    const buttonProps: SliceButton = {
      buttonVariant: null,
      buttonCTA: null,
      buttonOnclick: null
    };

    if (segmentIsLocked) {
      // Only show a button on the first item of the segment if it's locked
      if (block.firstIncomplete) {
        buttonProps.buttonVariant = SecondaryButton;
        buttonProps.buttonCTA = 'Upgrade';
        buttonProps.buttonOnclick = () => window.open(paths.plans());
      }
    } else {
      buttonProps.buttonVariant = block.firstIncomplete ? SecondaryButton : DefaultButton;
      buttonProps.buttonCTA = block.state === 'start' || block.state === 'complete' ? 'Start' : 'Continue';

      if (block.type === 'Lesson') {
        buttonProps.buttonOnclick = () =>
          (window.location.href = `${paths.lesson(block.lessonId)}?study_item=${block.id}`);
      } else if (block.type === 'Practice') {
        buttonProps.buttonOnclick = () => openModal(block.practiceBlocks);
      }
    }

    return buttonProps;
  };

  return (
    <div className={cx(style.segmentSlice, 'u-margin-H-l')}>
      <Row>
        <Col md={3} className={style.itemHeadline}>
          <h3 className={cx(style.number, 'u-margin-R-s')}>
            <strong>{number}</strong>
          </h3>
          <div>
            <h4 className="u-margin-B-n">{title}</h4>
            <p>
              <small>{pluralize(estimatedTimeMinutes, 'Minute')}</small>
            </p>
          </div>
        </Col>
        <Col md={9} className={style.itemWrapper}>
          {blocks.map((block) => {
            let blockProps;
            if (block.type === 'Lesson') {
              const article = [8, 11, 18].indexOf(block.estimatedTimeMinutes) !== -1 ? 'an' : 'a';

              blockProps = {
                icon: stateIcon[block.state],
                description: `Watch ${article} ${block.estimatedTimeMinutes} minute lesson video.`,
                title: 'Learn',
                ...buttonProps(block)
              };
            } else if (block.type === 'Practice') {
              blockProps = {
                icon: stateIcon[block.state],
                description: 'Check your knowledge with a short set of questions.',
                title: 'Practice',
                ...buttonProps(block)
              };
            }

            return (
              <Row key={block.id} className={cx(style.itemRow, 'u-padding-H-xs', 'u-padding-V-m')}>
                <Col xs={10} className={style.itemContent}>
                  <span className="text-primary u-margin-R-s" style={{ fontSize: '24px' }}>
                    <img src={blockProps.icon} />
                  </span>
                  <div>
                    <h4 className="u-margin-V-n">{blockProps.title}</h4>
                    <p className="u-margin-V-n">{blockProps.description}</p>
                  </div>
                </Col>
                <Col xs={2}>
                  {blockProps.buttonVariant && (
                    <blockProps.buttonVariant
                      className="u-margin-R-xs"
                      size="md"
                      onClick={blockProps.buttonOnclick}>
                      {blockProps.buttonCTA}
                    </blockProps.buttonVariant>
                  )}
                </Col>
              </Row>
            );
          })}
        </Col>
      </Row>
    </div>
  );
};

export default SegmentSlice;
